import { supabase, insertRow } from './engine';

// ============================================
// Notificaciones por correo (cobro / renovación / cumpleaños)
// ============================================
// Tolerante: si las tablas no existen en este entorno, devuelve valores
// seguros (deshabilitado) y el módulo simplemente no ofrece el envío.

export async function fetchNotifConfig() {
  try {
    const { data } = await supabase.from('notificacion_config').select('*').eq('id', 1).maybeSingle();
    return data || { habilitado: false };
  } catch { return { habilitado: false }; }
}

export async function fetchPlantillas() {
  try {
    const { data } = await supabase.from('notificacion_plantillas').select('*');
    const map = {};
    (data || []).forEach(p => { map[p.tipo] = p; });
    return map;
  } catch { return {}; }
}

// Reemplaza {{variable}} por su valor. Las que no existan quedan como '—'.
export function rellenar(texto, datos) {
  return String(texto || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) =>
    (datos && datos[k] != null && datos[k] !== '') ? String(datos[k]) : '—');
}

// Envía el correo (o lo registra si el envío aún está dormido) y SIEMPRE deja
// rastro en notificacion_envios (bitácora + futuro medidor de cuota).
// Devuelve { estado, asunto, cuerpo } — estado: enviado | no_configurado | error | registrado.
export async function enviarNotificacion({
  tipo, asunto, cuerpo, datos = {},
  cliente_id, poliza_id, destinatario, usuario_id, remitente,
}) {
  const asuntoFinal = rellenar(asunto, datos);
  const cuerpoFinal = rellenar(cuerpo, datos);

  let estado = 'registrado';
  let detalle = null;
  try {
    // Con la sesión: el enviador la exige (y es lo que identifica al corretaje ante el
    // servicio de correo de Corredata, que cuenta los envíos del plan).
    const { data: { session } } = await supabase.auth.getSession();
    const r = await fetch('/api/enviar-correo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
      },
      body: JSON.stringify({
        tipo,
        para: destinatario,
        asunto: asuntoFinal,
        texto: cuerpoFinal,
        remitente_nombre: remitente?.nombre || null,
        remitente_correo: remitente?.correo || null,
      }),
    });
    const data = await r.json().catch(() => ({}));
    if (data.ok) { estado = 'enviado'; detalle = data.id || null; }
    // El motivo legible (p. ej. cupo del plan agotado) queda en `detalle`, para mostrarlo.
    else { estado = data.reason === 'no_configurado' ? 'no_configurado' : 'error'; detalle = data.error || data.reason || 'error'; }
  } catch (e) {
    estado = 'error';
    detalle = String(e);
  }

  try {
    await insertRow('notificacion_envios', {
      tipo,
      cliente_id: cliente_id || null,
      poliza_id: poliza_id || null,
      destinatario: destinatario || null,
      asunto: asuntoFinal,
      estado,
      detalle,
      enviado_por: usuario_id || null,
    });
  } catch { /* el registro no debe tumbar el flujo */ }

  return { estado, detalle, asunto: asuntoFinal, cuerpo: cuerpoFinal };
}
